import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.agentAndAdmin,
	routes: [
		{
			path: '/contracts',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/contract-details/:id',
			exact: true,
			component: Page.ContractDetailsDailog
		},
	]
};